import { useState } from "react";

import { TAB } from "../misc/constants";

const useSuperadmin = () => {
    const [activeTab, setActiveTab] = useState(TAB.OPS);

    return { activeTab, setActiveTab };
};

export default useSuperadmin;
